import { useCallback } from 'react'
import { IImport } from '@user/store/import/typings'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@sales-center/common'
import { toast } from '@sales-center/components'

const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.downloadFile}`

export type ImportPropType = Pick<IImport, 'importId' | 'fileName' | 'id'>

export function useHandlers(props: ImportPropType) {
  const { importId } = props

  const downloadFile = useCallback(async (): Promise<void> => {
    try {
      const response = await get(`${url}/${importId}`)

      if (!response.ok) {
        throw new Error(`${response.status}`)
      }

      const fileUrl: string = await response.json()

      if (fileUrl) window.location.href = fileUrl
    } catch (error) {
      toast.error('Original File Download failed.')
      console.error('Download Error:', error)
    }
  }, [importId])

  return {
    downloadFile,
  }
}

export type UseHandlers = ReturnType<typeof useHandlers>
